package one.healthium.domain.common


import kotlinx.serialization.Contextual
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class TextStyle(
    @SerialName("color") @Contextual val color: Color? = null,
    @SerialName("font_style") val fontWeight: String? = null,
    @SerialName("font_size") val fontSize: Int? = null,
    @SerialName("alignment") val alignment: String? = null,
)